import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import Index from '../views/Index.vue';
import Admin from '../views/Admin.vue';
const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Index',
    redirect: '/home',
    component: Index,
    children:[
      {
        path: '/home',
        name: 'Home',
        component: () => import(/* webpackChunkName: "about" */ '../components/Home.vue'),
      },
      {
        path: '/showAchievement',
        name: 'ShowAchievement',
        component: () => import(/* webpackChunkName: "about" */ '../components/ShowAchievement.vue'),
      },
      {
        path: '/laboratory',
        name: 'Laboratory',
        component: () => import(/* webpackChunkName: "about" */ '../components/Laboratory.vue'),
      },
      {
        path: '/news',
        name: 'News',
        component: () => import(/* webpackChunkName: "about" */ '../components/News.vue'),
      },
      {
        path: '/joinUs',
        name: 'JoinUs',
        component: () => import(/* webpackChunkName: "about" */ '../components/JoinUs.vue'),
      },
      {
        path: '/cooperate',
        name: 'Cooperate',
        component: () => import(/* webpackChunkName: "about" */ '../components/Cooperate.vue'),
      },
      {
        path: '/data',
        name: 'Data',
        component: () => import(/* webpackChunkName: "about" */ '../components/Data.vue'),
      },
      {
        path: '/papers',
        name: 'Papers',
        component: () => import(/* webpackChunkName: "about" */ '../components/Papers.vue'),
      },
      {
        path: '/patents',
        name: 'Patents',
        component: () => import(/* webpackChunkName: "about" */ '../components/Patents.vue'),
      },
      {
        path: '/awards',
        name: 'Awards',
        component: () => import(/* webpackChunkName: "about" */ '../components/Awards.vue'),
      },
      {
        path: '/personalProfile',
        name: 'PersonalProfile',
        component: () => import(/* webpackChunkName: "about" */ '../components/PersonalProfile.vue'),
      },
      {
        path: '/graduates',
        name: 'Graduates',
        component: () => import(/* webpackChunkName: "about" */ '../components/Graduates.vue'),
      },
      {
        path: '/researchAreas',
        name: 'ResearchAreas',
        component: () => import(/* webpackChunkName: "about" */ '../components/ResearchAreas.vue'),
      },
      {
        path: '/search',
        name: 'Search',
        component: () => import(/* webpackChunkName: "about" */ '../components/Search.vue'),
      },
    ]
  },
  {
    path: '/admin',
    name: 'Admin',
    redirect: '/admin/previewHome',
    component: Admin,
    children:[
      {
        path:'previewHome',
        name:'PreviewHome',
        component: () => import(/* webpackChunkName: "about" */ '../components/admin/PreviewHome.vue'),
      },
      {
        path:'article',
        name:'Article',
        component: () => import(/* webpackChunkName: "about" */ '../components/admin/Article.vue'),
      },
      {
        path:'postArticle',
        name:'PostArticle',
        component: () => import(/* webpackChunkName: "about" */ '../components/admin/PostArticle.vue'),
      },
      {
        path:'category',
        name:'Category',
        component: () => import(/* webpackChunkName: "about" */ '../components/admin/Category.vue'),
      },
      {
        path:'label',
        name:'Label',
        component: () => import(/* webpackChunkName: "about" */ '../components/admin/Label.vue'),
      },
      {
        path:'teacher',
        name:'Teacher',
        component: () => import(/* webpackChunkName: "about" */ '../components/admin/Teacher.vue'),
      },
      {
        path:'postgraduate',
        name:'Postgraduate',
        component: () => import(/* webpackChunkName: "about" */ '../components/admin/Postgraduate.vue'),
      },
      {
        path:'user',
        name:'User',
        component: () => import(/* webpackChunkName: "about" */ '../components/admin/User.vue'),
      },
      
    ]
  },
  {
    path:'/login',
    name:'Login',
    component: () => import(/* webpackChunkName: "about" */ '../components/admin/AdminLogin.vue'),
  },
  
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
